<template>
  <header>
    <div class="content">
      <div class="header">
        <div class="header__logo">
          <div>
            <img class="header__logo_image01" src="../assets/image/01.jpg" alt="三菱商事ロジスティクス株式会社 MCLOGI" width="913" height="170" />
          </div>
          <div>
            <img class="header__logo_image02" src="../assets/image/02.jpg" alt="三菱商事ロジスティクス株式会社 MCLOGI" width="1134" height="80" />
          </div>
        </div>
        <div class="header__buttons">
          <div class="header__buttons_button lbl_btn">
            <a href="matching_service_introduction_materials.pdf" download="サービス紹介資料 -三菱商事ロジスティクス㈱.pdf" v-on:click="trackDownload">資料はこちら</a>
          </div>
          <div class="header__buttons_button org_btn">
            <a href="javascript:void(0);" v-on:click.prevent="trackMailTo">お問い合わせ</a>
          </div>
        </div>
      </div>
    </div>
  </header>

  <main>
    <section class="fv">
      <div class="fv__image">
      </div>
      <div class="fv__content content">
      </div>
    </section>

    <section class="form">
      <div class="content" ref="form_tab">
        <div class="form__title__image">
          <img src="../assets/image/form_title_image1.png" alt="メインビジュアル：三菱商事ロジスティクス株式会社のWeb見積サービス。国際物流に欠かせない、コンテナの海上輸送料金をWebで簡単に取得できます。会員登録やログイン不要、どなたにも無料、最短即日で見積もり情報をメールにてお送りいたします。" width="4031" height="984" />
        </div>
      </div>
      <div class="form__tab content">
        <datalist id="portlist">
          <option v-for="port in ports" :key="port.id" :value="port.short_name"></option>
        </datalist>
        <!-- タブ1 -->
        <label>
          <input type="radio" name="form_tab01" value="0" v-model.number="rough_estimate.transport_fee_tab" v-on:click="tabChanged()">
          <span>海上輸送料金を調べる</span>
        </label>
        <template v-if="rough_estimate.transport_fee_tab == 0">
        <div class="form__body">
          <div class="text--right mb--10">*は必須項目</div>
          <form>
            <div class="form_body__content">
              <div class="form__body__form">
                <ul class="form__body__list">
                  <li v-for="(route, index) in sea_route_inquiry" :key="index">
                    <dl class="required">
                      <dt><label :for="'sea-POL' + index">積港(POL)</label><span class="text--bold">*</span></dt>
                      <dd>
                        <input :name="'sea-POL' + index" :id="'sea-POL' + index" type="text" list="portlist" v-model="route.pol">
                      </dd>
                    </dl>
                    <dl class="required">
                      <dt><label :for="'sea-POD' + index">揚港(POD)</label><span class="text--bold">*</span></dt>
                      <dd>
                        <input :name="'sea-POD' + index" :id="'sea-POD' + index" type="text" list="portlist" v-model="route.pod">
                      </dd>
                      <dd class="direct-check">
                        <label :for="'sea-direct' + index" class="form__checkbox">Direct便に限定<input :name="'sea-direct' + index" :id="'sea-direct' + index" type="checkbox" v-model="route.direct_delivery"><i></i></label>
                      </dd>
                    </dl>
                    <dl class="required">
                      <dt><label :for="'sea-container' + index">コンテナタイプ</label><span class="text--bold">*</span></dt>
                      <dd class="ft-checkboxes">
                        <label :for="'sea-container20ft'+ index" class="form__checkbox">20ft<input :name="'sea-container20ft' + index" :id="'sea-container20ft' + index" type="checkbox" v-model="route.container_type_20ft"><i></i></label>
                        <label :for="'sea-container40ft'+ index" class="form__checkbox">40ft<input :name="'sea-container40ft' + index" :id="'sea-container40ft' + index" type="checkbox" v-model="route.container_type_40ft"><i></i></label>
                      </dd>
                      <dd class="kind-selects">
                        <span>種類</span>
                        <select :id="'sea-container' + index" :name="'sea-container' + index" v-model.number="route.container_type">
                          <option v-for="(container_type, index) in container_types" :key="index" :value="container_type.id">{{container_type.container_type}}</option>
                        </select>
                      </dd>
                    </dl>
                    <dl>
                      <dt><label :for="'sea-dangerous' + index">危険品</label></dt>
                      <dd class="dangerous-check">
                        <label :for="'sea-dangerous' + index" class="form__checkbox"><input :name="'sea-dangerous' + index" :id="'sea-dangerous' + index" type="checkbox" v-model="route.dangerous_goods"><i></i></label>
                      </dd>
                    </dl>
                    <dl>
                      <dt><label :for="'sea-frequency' + index">出荷本数/月</label></dt>
                      <dd><input :name="'sea-frequency' + index" :id="'sea-frequency' + index" type="text" maxlength="3" v-model.number="route.number_of_shipments"></dd>
                    </dl>
                  </li>
                </ul>
                <div class="add_row_button"><span>他航路も依頼する方はコチラ</span><button type="button" v-on:click.prevent="addSeaRouteInquiry()">入力航路追加</button></div>
              </div>
              <div class="form__error__text">
                <p v-for="(error1,index) in errors1" :key="index">{{error1}}</p>
              </div>
              <div class="form__body__email">
                <div class="request-text">
                  <label for="sea-other_request">その他リクエスト</label>
                  <input type="text" name="sea-other_request" id="sea-other_request" placeholder="フリータイム条件や荷姿など（任意）" v-model="rough_estimate.request">
                </div>
                <div class="price-text">
                  <label>希望輸送料金</label>
                  <input type="text" name="sea-price1" id="sea-price1" placeholder="任意" v-model="rough_estimate.desired_transportation_fee">
                </div>
                <button type="button" class="sea-mail-btn" v-on:click.prevent="errCheck1()"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. --><path d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm0 48v40.8c-22.4 18.3-58.2 46.7-134.6 106.5-16.8 13.2-50.2 45.1-73.4 44.7-23.2 .4-56.6-31.5-73.4-44.7C106.2 199.5 70.4 171.1 48 152.8V112h416zM48 400V214.4c22.9 18.3 55.4 43.9 104.9 82.6 21.9 17.2 60.1 55.2 103.1 55 42.7 .2 80.5-37.2 103.1-54.9 49.5-38.8 82-64.4 104.9-82.7V400H48z"/></svg>メールアドレス入力へ<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!-- !Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. --><path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"/></svg></button>
              </div>

              <div class="form__modal" :class="{'show': dialogModal}">
                <div class="form__modal__content">
                  <div class="form__modal__content__title">
                    <h2>ご連絡先を入力してください</h2>
                  </div>
                  <div class="form__modal__content__body">
                    <ul class="form__modal__list">
                      <li>
                        <label for="sea-name">
                          <input id="sea-name" name="sea-name" type="text" placeholder="お名前" v-model="rough_estimate.person_in_charge">
                        </label>
                      </li>
                      <li>
                        <label for="sea-company">
                          <input id="sea-company" name="sea-company" type="text" placeholder="会社名" v-model="rough_estimate.company_name">
                        </label>
                      </li>
                      <li>
                        <label for="sea-email">
                          <input id="sea-email" name="sea-email" type="text" placeholder="配信先アドレス（フリーメール/キャリアメール不可）" v-model="rough_estimate.email">
                        </label>
                      </li>
                      <li>
                        <label for="sea-email2">
                          <input id="sea-email2" name="sea-email2" type="text" placeholder="配信先アドレス（再入力）" v-model="rough_estimate.email_conf">
                        </label>
                      </li>
                      <li>
                        <label for="sea-tel">
                          <input id="sea-tel" name="sea-tel" type="text" placeholder="電話番号" v-model="rough_estimate.tel">
                        </label>
                      </li>
                      <li>
                        <label for="sea-shipping">
                          <input id="sea-shipping" name="sea-shipping" type="text" placeholder="貨物内容" v-model="rough_estimate.cargo_contents">
                        </label>
                      </li>
                      <li>
                        <label for="sea-purpose">
                          <select id="sea-purpose" name="sea-purpose" class="purpose_select"  :class="{'selected': rough_estimate.purpose_of_inquiry_type != -1}" v-model.number="rough_estimate.purpose_of_inquiry_type">
                            <option value="-1" disabled selected>お問い合わせ目的</option>
                            <option v-for="(landSea_purpose, index) in landSea_purposes" :key="index" :value="landSea_purpose.id">{{landSea_purpose.landSea_purpose}}</option>
                          </select>
                        </label>
                      </li>
                      <li v-if="rough_estimate.purpose_of_inquiry_type == 4">
                        <label for="sea-purpose-text">
                          <textarea id="sea-purpose-text" name="sea-purpose-text" class="purpose_textarea" placeholder="お問い合わせの目的をお知らせください（自由記述）" rows="2" v-model="rough_estimate.purpose_of_inquiry_text"></textarea>
                        </label>
                      </li>
                    </ul>
                    <div class="form__modal__privacy">
                      <div class="form__modal__privacy__text">
                        <!-- TODO: プライバシーポリシーのリンク先を設定 -->
                        <a href="javascript:void(0);" v-on:click="popupAgreement()">利用規約</a>に同意する
                      </div>
                      <div class="form__modal__privacy__check">
                        <input id="sea-privacy" name="sea-privacy" type="checkbox" v-model="privacy_chk"><label for="sea-privacy"></label>
                      </div>
                    </div>
                    <div class="form__error__text">
                      <p v-for="(error2,index) in errors2" :key="index">{{error2}}</p>
                    </div>
                    <div class="form__modal__button">
                      <button type="button" class="sea-submit" v-on:click.prevent="postRequest">確定する<br>（無料）</button>
                      <button type="button" class="form__modal__button__back" v-on:click.prevent="dialogModal = false">閉じる</button>
                    </div>
                  </div>
                  <div class="form__modal__close" v-on:click.prevent="dialogModal = false"></div>
                </div>
              </div>

            </div>
          </form>
        </div>
        </template>
        <!-- /タブ1 -->

        <!-- タブ2 -->
        <label>
          <input type="radio" name="form_tab01" value="1"  v-model.number="rough_estimate.transport_fee_tab" v-on:click="tabChanged()">
          <span>海上＋内陸輸送料金を調べる</span>
        </label>
        <template v-if="rough_estimate.transport_fee_tab == 1">
        <div class="form__body">
          <div class="text--right mb--10">*は必須項目</div>
          <form>
            <!-- 輸出入選択 -->
            <div class="tradeType">
              <label for="exportButton"><input type="radio" name="export_import" id="exportButton" value="0" v-model.number="rough_estimate.export_import_flg">輸出</label>
              <label for="importButton"><input type="radio" name="export_import" id="importButton" value="1" v-model.number="rough_estimate.export_import_flg">輸入</label>
            </div>
            <div class="form_body__content bg">
              <div class="form__body__form">
                <ul class="form__body__list">
                  <li v-for="(route, index) in sea_route_inquiry" :key="index">
                    <dl class="required">
                      <dt><label :for="'sea-POL' + index">積港(POL)</label><span class="text--bold">*</span></dt>
                      <dd>
                        <input :name="'sea-POL' + index" :id="'sea-POL' + index" type="text" list="portlist" v-model="route.pol">
                      </dd>
                    </dl>
                    <dl class="required">
                      <dt><label :for="'sea-POD' + index">揚港(POD)</label><span class="text--bold">*</span></dt>
                      <dd>
                        <input :name="'sea-POD' + index" :id="'sea-POD' + index" type="text" list="portlist" v-model="route.pod">
                      </dd>
                      <dd class="direct-check">
                        <label :for="'sea-direct' + index" class="form__checkbox">Direct便に限定<input :name="'sea-direct' + index" :id="'sea-direct' + index" type="checkbox" v-model="route.direct_delivery"><i></i></label>
                      </dd>
                    </dl>
                    <dl class="required">
                      <dt><label :for="'sea-container' + index">コンテナタイプ</label><span class="text--bold">*</span></dt>
                      <dd class="ft-checkboxes">
                        <label :for="'sea-container20ft'+ index" class="form__checkbox">20ft<input :name="'sea-container20ft' + index" :id="'sea-container20ft' + index" type="checkbox" v-model="route.container_type_20ft"><i></i></label>
                        <label :for="'sea-container40ft'+ index" class="form__checkbox">40ft<input :name="'sea-container40ft' + index" :id="'sea-container40ft' + index" type="checkbox" v-model="route.container_type_40ft"><i></i></label>
                      </dd>
                      <dd class="kind-selects">
                        <span>種類</span>
                        <select :id="'sea-container' + index" :name="'sea-container' + index" v-model.number="route.container_type">
                          <option v-for="(container_type, index) in container_types" :key="index" :value="container_type.id">{{container_type.container_type}}</option>
                        </select>
                      </dd>
                    </dl>
                    <dl>
                      <dt><label :for="'sea-dangerous' + index">危険品</label></dt>
                      <dd class="dangerous-check">
                        <label :for="'sea-dangerous' + index" class="form__checkbox"><input :name="'sea-dangerous' + index" :id="'sea-dangerous' + index" type="checkbox" v-model="route.dangerous_goods"><i></i></label>
                      </dd>
                    </dl>
                    <dl>
                      <dt><label :for="'sea-frequency' + index">出荷本数/月</label></dt>
                      <dd><input :name="'sea-frequency' + index" :id="'sea-frequency' + index" type="text" maxlength="3" v-model.number="route.number_of_shipments"></dd>
                    </dl>
                  </li>
                </ul>
                <div class="add_row_button"><span>他航路も依頼する方はコチラ</span><button type="button" v-on:click.prevent="addSeaRouteInquiry()">入力航路追加</button></div>
              </div>

              <div class="form__body__options">
                <ul>
                  <!-- 輸出選択時表示見積項目 -->
                  <template v-if="rough_estimate.export_import_flg == '0'">
                  <li class="options__lists is-export">
                    <div class="option__title">
                      <span>日本(輸出地) 見積項目</span>
                      <div class="radios">
                        <label for="JPExportEstimateRequiredTrue"><input type="radio" name="JPExportEstimateRequired" id="JPExportEstimateRequiredTrue" value="1"  v-model.number="rough_estimate.exp.e_place_flg" v-on:click="defaultExpExp()">必要</label>
                        <label for="JPExportEstimateRequiredFalse"><input type="radio" name="JPExportEstimateRequired" id="JPExportEstimateRequiredFalse" value="0" v-model.number="rough_estimate.exp.e_place_flg" v-on:click="clearExpExp()">不要</label>
                      </div>
                      <div class="checkbox">
                        <label>わからない(相談したい）<input type="checkbox" name="JPExportEstimateConsultation" v-model.number="rough_estimate.exp.e_consultation"><i></i></label>
                      </div>
                    </div>
                    <div class="option__input">
                      <ul class="option__input__list">
                        <li>
                          <label>
                            集荷<input type="checkbox" name="JPExportEstimateOptions" v-model.number="rough_estimate.exp.e_shipping" :disabled="rough_estimate.exp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            輸出梱包<input type="checkbox" name="JPExportEstimateOptions" v-model.number="rough_estimate.exp.e_packaging" :disabled="rough_estimate.exp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            コンテナへの積込<br>（バンニング）<input type="checkbox" name="JPExportEstimateOptions" v-model.number="rough_estimate.exp.e_banning" :disabled="rough_estimate.exp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            港へのコンテナ輸送<br>（ドレージ）<input type="checkbox" name="JPExportEstimateOptions" v-model.number="rough_estimate.exp.e_drayage" :disabled="rough_estimate.exp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            輸出通関<input type="checkbox" name="JPExportEstimateOptions" v-model.number="rough_estimate.exp.e_customs_clearance" :disabled="rough_estimate.exp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                      </ul>
                      <div class="option__input__address input-disabled">
                        <label for="JPExportEstimateAddress">集荷先住所</label>
                        <input type="text" name="JPExportEstimateAddress" id="JPExportEstimateAddress" placeholder="「OO市内」のみでも可" v-model="rough_estimate.exp.e_pickup_address" :disabled="rough_estimate.exp.e_place_flg == 0 || !rough_estimate.exp.e_shipping">
                      </div>
                    </div>
                  </li>
                  </template>

                  <template v-if="rough_estimate.export_import_flg == '0'">
                  <!-- 輸出選択時表示見積項目 -->
                  <li class="options__lists is-export">
                    <div class="option__title">
                      <span>外地(輸入地) 見積項目</span>
                      <div class="radios">
                        <label for="ForeignImportEstimateRequiredTrue"><input type="radio" name="ForeignImportEstimateRequired" id="ForeignImportEstimateRequiredTrue" value="1" v-model.number="rough_estimate.exp.i_place_flg" v-on:click="defaultExpImp()">必要 </label>
                        <label for="ForeignImportEstimateRequiredFalse"><input type="radio" name="ForeignImportEstimateRequired" id="ForeignImportEstimateRequiredFalse" value="0" v-model.number="rough_estimate.exp.i_place_flg" v-on:click="clearExpImp()">不要</label>
                      </div>
                      <div class="checkbox">
                        <label>わからない(相談したい）<input type="checkbox" name="ForeignImportEstimateConsultation" v-model.number="rough_estimate.exp.i_consultation"><i></i></label>
                      </div>
                    </div>
                    <div class="option__input">
                      <ul class="option__input__list">
                        <li>
                          <label>
                            輸入通関<input type="checkbox" name="ForeignImportEstimateOptions" v-model.number="rough_estimate.exp.i_customs_clearance" :disabled="rough_estimate.exp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            港からのコンテナ輸送<br>（ドレージ）<input type="checkbox" name="ForeignImportEstimateOptions" v-model.number="rough_estimate.exp.i_drayage" :disabled="rough_estimate.exp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            コンテナからの荷卸し<br>（デバンニング）<input type="checkbox" name="ForeignImportEstimateOptions" v-model.number="rough_estimate.exp.i_devanning" :disabled="rough_estimate.exp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            開梱<input type="checkbox" name="ForeignImportEstimateOptions" v-model.number="rough_estimate.exp.i_unpacking" :disabled="rough_estimate.exp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                           配送<br>（荷卸し後の貨物）<input type="checkbox" name="ForeignImportEstimateOptions" v-model.number="rough_estimate.exp.i_delivery" :disabled="rough_estimate.exp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                      </ul>
                      <div class="option__input__address input-disabled">
                        <label for="ForeignImportEstimateAddress">お届け先住所</label>
                        <input type="text" name="ForeignImportEstimateAddress" id="ForeignImportEstimateAddress" placeholder="「OO市内」のみでも可" v-model="rough_estimate.exp.i_shipping_address" :disabled="rough_estimate.exp.i_place_flg == 0 || (!rough_estimate.exp.i_drayage && !rough_estimate.exp.i_delivery)">
                      </div>
                    </div>
                  </li>
                  </template>

                  <template v-if="rough_estimate.export_import_flg == '1'">
                  <!-- 輸入選択時表示見積項目 -->
                  <li class="options__lists is-import">
                    <div class="option__title">
                      <span>日本(輸入地) 見積項目</span>
                      <div class="radios">
                        <label for="JPImportEstimateRequiredTrue"><input type="radio" name="JPImportEstimateRequired"  id="JPImportEstimateRequiredTrue" value="1" v-model.number="rough_estimate.imp.i_place_flg" v-on:click="defaultImpImp()">必要</label>
                        <label for="JPImportEstimateRequiredFalse"><input type="radio" name="JPImportEstimateRequired"  id="JPImportEstimateRequiredFalse" value="0" v-model.number="rough_estimate.imp.i_place_flg" v-on:click="clearImpImp()">不要</label>
                      </div>
                      <div class="checkbox">
                        <label>わからない(相談したい）<input type="checkbox" name="JPImportEstimateConsultation" v-model.number="rough_estimate.imp.i_consultation"><i></i></label>
                      </div>
                    </div>
                    <div class="option__input">
                      <ul class="option__input__list">
                        <li>
                          <label>
                            輸入通関<input type="checkbox" name="JPImportEstimateOptions" v-model.number="rough_estimate.imp.i_customs_clearance" :disabled="rough_estimate.imp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            港からのコンテナ輸送<br>（ドレージ）<input type="checkbox" name="JPImportEstimateOptions" v-model.number="rough_estimate.imp.i_drayage" :disabled="rough_estimate.imp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            コンテナからの荷卸し<br>（デバンニング）<input type="checkbox" name="JPImportEstimateOptions" v-model.number="rough_estimate.imp.i_devanning" :disabled="rough_estimate.imp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            開梱<input type="checkbox" name="JPImportEstimateOptions" v-model.number="rough_estimate.imp.i_unpacking" :disabled="rough_estimate.imp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            配送<br>（荷卸し後の貨物）<input type="checkbox" name="JPImportEstimateOptions" v-model.number="rough_estimate.imp.i_delivery" :disabled="rough_estimate.imp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                      </ul>
                      <div class="option__input__address input-disabled">
                        <label for="JPImportEstimateAddress">お届け先住所</label>
                        <input type="text" name="JPImportEstimateAddress" id="JPImportEstimateAddress" placeholder="「OO市内」のみでも可" v-model="rough_estimate.imp.i_shipping_address" :disabled="rough_estimate.imp.i_place_flg == 0 || (!rough_estimate.imp.i_drayage && !rough_estimate.imp.i_delivery)">
                      </div>
                    </div>
                  </li>
                  </template>
                  <template v-if="rough_estimate.export_import_flg == '1'">
                  <!-- 輸入選択時表示見積項目 -->
                  <li class="options__lists is-import">
                    <div class="option__title">
                      <span>外地(輸出地) 見積項目</span>
                      <div class="radios">
                        <label for="ForeignExportEstimateRequiredTrue"><input type="radio" name="ForeignExportEstimateRequired" id="ForeignExportEstimateRequiredTrue" value="1"  v-model.number="rough_estimate.imp.e_place_flg" v-on:click="defaultImpExp()">必要</label>
                        <label for="ForeignExportEstimateRequiredFalse"><input type="radio" name="ForeignExportEstimateRequired" id="ForeignExportEstimateRequiredFalse" value="0" v-model.number="rough_estimate.imp.e_place_flg" v-on:click="clearImpExp()">不要</label>
                      </div>
                      <div class="checkbox">
                        <label>わからない(相談したい）<input type="checkbox" name="ForeignExportEstimateConsultation" v-model.number="rough_estimate.imp.e_consultation"><i></i></label>
                      </div>
                    </div>
                    <div class="option__input">
                      <ul class="option__input__list">
                        <li>
                          <label>
                            集荷<input type="checkbox" name="ForeignExportEstimateOptions" v-model.number="rough_estimate.imp.e_shipping" :disabled="rough_estimate.imp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            輸出梱包<input type="checkbox" name="ForeignExportEstimateOptions" v-model.number="rough_estimate.imp.e_packaging" :disabled="rough_estimate.imp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            コンテナへの積込<br>（バンニング）<input type="checkbox" name="ForeignExportEstimateOptions" v-model.number="rough_estimate.imp.e_banning" :disabled="rough_estimate.imp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            港へのコンテナ輸送<br>（ドレージ）<input type="checkbox" name="ForeignExportEstimateOptions" v-model.number="rough_estimate.imp.e_drayage" :disabled="rough_estimate.imp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            輸出通関<input type="checkbox" name="ForeignExportEstimateOptions" v-model.number="rough_estimate.imp.e_customs_clearance" :disabled="rough_estimate.imp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                      </ul>
                      <div class="option__input__address input-disabled">
                        <label for="ForeignExportEstimateAddress">集荷先住所</label>
                        <input type="text" name="ForeignExportEstimateAddress" id="ForeignExportEstimateAddress" placeholder="「OO市内」のみでも可" v-model="rough_estimate.imp.e_pickup_address" :disabled="rough_estimate.imp.e_place_flg == 0 || !rough_estimate.imp.e_shipping">
                      </div>
                    </div>
                  </li>
                  </template>

                  <!-- その他条件 -->
                  <li class="options__lists">
                    <div class="option__title">
                      <span>その他条件</span>
                    </div>
                    <div class="option__input">
                      <ul class="option__input__list">
                        <li>
                          <label>
                            貨物保険<input type="checkbox" name="OtherEstimateInsurance" v-model="rough_estimate.cargo_insurance"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            貨物荷姿
                            <select name="OtherEstimatePacking" v-model="rough_estimate.cargo_packaging">
                              <option v-for="(cargo_packaging, index) in cargo_packagings" :key="index" :value="cargo_packaging.id">{{cargo_packaging.cargo_packaging}}</option>
                            </select>
                          </label>
                        </li>
                        <li>
                          <label>
                            重量(Kg)<br>/CNTR<input type="text" name="OtherEstimateWeight" placeholder="（半角数字）" maxlength="9" v-model="rough_estimate.weight">
                          </label>
                        </li>
                        <li>
                          <label>
                            M3<br>/CNTR<input type="text" name="OtherEstimateM3" placeholder="（半角数字）" maxlength="9" v-model="rough_estimate.m3">
                          </label>
                        </li>
                        <li>
                          <label>
                            出荷時期
                            <select name="OtherEstimateShipment" v-model="rough_estimate.shipping_time">
                              <option v-for="(shipping_time, index) in shipping_times" :key="index" :value="shipping_time.id">{{shipping_time.shipping_time}}</option>
                            </select>
                          </label>
                        </li>
                      </ul>
                      <ul class="option__input__list">
                        <li>
                          <label>
                            その他リクエスト
                            <input type="text" name="OtherEstimateRequest" class="option__input-text" placeholder="フリータイム条件や荷姿など（任意）" v-model="rough_estimate.request">
                          </label>
                        </li>
                        <li>
                          <label>
                            希望輸送料金
                            <input type="text" name="OtherEstimatePrice" placeholder="（任意）" v-model="rough_estimate.desired_transportation_fee">
                          </label>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>


              <div class="form__body__email">
                <div class="form__error__text">
                  <p v-for="(error1,index) in errors1" :key="index">{{error1}}</p>
                </div>
                <button type="button" class="landSea-mail-btn" v-on:click.prevent="errCheck1()"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. --><path d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm0 48v40.8c-22.4 18.3-58.2 46.7-134.6 106.5-16.8 13.2-50.2 45.1-73.4 44.7-23.2 .4-56.6-31.5-73.4-44.7C106.2 199.5 70.4 171.1 48 152.8V112h416zM48 400V214.4c22.9 18.3 55.4 43.9 104.9 82.6 21.9 17.2 60.1 55.2 103.1 55 42.7 .2 80.5-37.2 103.1-54.9 49.5-38.8 82-64.4 104.9-82.7V400H48z"/></svg>メールアドレス入力へ<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!-- !Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. --><path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"/></svg></button>
              </div>

              <div class="form__modal" :class="{'show': dialogModal}">
                <div class="form__modal__content">
                  <div class="form__modal__content__title">
                    <h2>ご連絡先を入力してください</h2>
                  </div>
                  <div class="form__modal__content__body">
                    <ul class="form__modal__list">
                      <li>
                        <label for="landSea-name">
                          <input id="landSea-name" name="landSea-name" type="text" placeholder="お名前" v-model="rough_estimate.person_in_charge">
                        </label>
                      </li>
                      <li>
                        <label for="landSea-company">
                          <input id="landSea-company" name="landSea-company" type="text" placeholder="会社名" v-model="rough_estimate.company_name">
                        </label>
                      </li>
                      <li>
                        <label for="landSea-email">
                          <input id="landSea-email" name="landSea-email" type="text" placeholder="配信先アドレス（フリーメール/キャリアメール不可）" v-model="rough_estimate.email">
                        </label>
                      </li>
                      <li>
                        <label for="landSea-email2">
                          <input id="landSea-email2" name="landSea-email2" type="text" placeholder="配信先アドレス（再入力）" v-model="rough_estimate.email_conf">
                        </label>
                      </li>
                      <li>
                        <label for="landSea-tel">
                          <input id="landSea-tel" name="landSea-tel" type="text" placeholder="電話番号" v-model="rough_estimate.tel">
                        </label>
                      </li>
                      <li>
                        <label for="landSea-shipping">
                          <input id="landSea-shipping" name="landSea-shipping" type="text" placeholder="貨物内容" v-model="rough_estimate.cargo_contents">
                        </label>
                      </li>
                      <li>
                        <label for="sea-purpose">
                          <select id="sea-purpose" name="sea-purpose" class="purpose_select" :class="{'selected': rough_estimate.purpose_of_inquiry_type != -1}" v-model.number="rough_estimate.purpose_of_inquiry_type">
                            <option value="-1" disabled selected>お問い合わせ目的</option>
                            <option v-for="(landSea_purpose, index) in landSea_purposes" :key="index" :value="landSea_purpose.id">{{landSea_purpose.landSea_purpose}}</option>
                          </select>
                        </label>
                      </li>
                      <li v-if="rough_estimate.purpose_of_inquiry_type == 4">
                        <label for="sea-purpose-text">
                          <textarea id="sea-purpose-text" name="sea-purpose-text" class="purpose_textarea" placeholder="お問い合わせの目的をお知らせください（自由記述）" rows="2" v-model="rough_estimate.purpose_of_inquiry_text"></textarea>
                        </label>
                      </li>
                    </ul>
                    <div class="form__modal__privacy">
                      <div class="form__modal__privacy__text">
                        <!-- TODO: プライバシーポリシーのリンク先を設定 -->
                        <a href="javascript:void(0);" v-on:click="popupAgreement()">利用規約</a>に同意する
                      </div>
                      <div class="form__modal__privacy__check">
                        <input id="landSea-privacy" name="landSea-privacy" type="checkbox" v-model="privacy_chk"><label for="landSea-privacy"></label>
                      </div>
                    </div>
                    <div class="form__error__text">
                      <p v-for="(error2,index) in errors2" :key="index">{{error2}}</p>
                    </div>
                    <div class="form__modal__button">
                      <button type="button" class="landSea-submit" v-on:click.prevent="postRequest">確定する<br>（無料）</button>
                      <button type="button" class="form__modal__button__back" v-on:click.prevent="dialogModal = false">閉じる</button>
                    </div>
                  </div>
                  <div class="form__modal__close" v-on:click.prevent="dialogModal = false"></div>
                </div>
              </div>
            </div>

          </form>
        </div>
        <!-- /タブ2 -->
        </template>
      </div>
    </section>

    <section class="campaign">
      <div class="content">
        <div class="campaign__title">
          <h2>海上輸送 ネットワーク</h2>
        </div>
        <div class="campaign__body">
          <ul>
            <li v-for="image in campaigns" :key="image.pic_id">
              <div class="campaign__body__image">
                <img :src="require('@/assets/image/'+ image.pic_id + '.png')" :alt="image.alt" width="1260" height="1151" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="guide" id="flow">
      <div class="content">
        <div class="guide__title">
          <h2>サービスの特徴</h2>
        </div>
        <div class="guide__body">
          <ul>
            <li class="guide__item">
              <div class="guide__image">
                <img src="../assets/image/guide_image01.png" alt="本サービスの利用には会員登録は不要であり、サービス利用料も無料です。どなたでも、お気軽に国際輸送料金をお調べいただけるWeb見積サービスです。Ocean Freight やContainer FreightのWeb Quote取得の簡素化に役立ちます。" width="1236" height="985" />
              </div>
            </li>
            <li class="guide__arrow">
              <i><img src="../assets/image/arrow_down-1.svg" alt="" width="100" height="100" class="arrow_down" /></i>
            </li>
            <li class="guide__item">
              <div class="guide__image">
                <img src="../assets/image/guide_image02.png" alt="さまざまな輸送モードや輸出入に関わる国内作業費用の見積もりが可能です。海上運賃のみならず、内陸トラック・鉄道輸送の料金、通関費用、倉庫保管料にも対応しております。" width="1236" height="985" />
              </div>
            </li>
            <li class="guide__arrow">
              <i><img src="../assets/image/arrow_down-1.svg" alt="" width="100" height="100" class="arrow_down" /></i>
            </li>
            <li class="guide__item">
              <div class="guide__image">
                <img src="../assets/image/guide_image03.png" alt="入力時間はわずか1分。国際物流に関わる海上運賃やトラック費用、通関コストの調査や比較、検証、推移や市況の確認を目的に利用可能。輸出にも輸入にも三国間にも対応しており、メールで見積をご案内致します。" width="1236" height="985" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 危険物輸送もMCLOGIにお任せ！-->
    <section class="dangerous" id="dangerous">
      <div class="content">
        <div class="dangerous__title">
          <h2>危険物の国際輸送もMCLOGIにお任せ！</h2>
        </div>
        <div class="dangerous__message">
          <p>危険物は通常貨物とは異なるルールの確認が必要になり、また船会社によって取扱い基準が様々です。<br>弊社ではIMOルールの確認や船積みの実現に向けた船社との交渉など、長年の経験・実績を基に輸送を手配します。お気軽にご相談下さい。</p>
          <div class="dangerous__message__img">
            <img src="../assets/image/dangerous.jpg" alt="危険物輸送（危険品輸送）には、法令の順守や、輸送の安全性などが求められます。三菱商事ロジスティクスでは豊富な危険物取り扱い経験・実績を基に、お客様の海上輸送オプションの拡大のため、様々な国際輸送サービスをご提案します。取扱実績としてはクラス3：引火性液体類、クラス8：腐食性物質、クラス5：酸化性物質類、クラス9：有害性物質などがあります。" width="3304" height="1104">
            <div class="text--right">*上記以外でも対応可能です、ぜひお問合せください。</div>
          </div>
        </div>
        <div class="dangerous__button">
          <a class="dangerous__button__contact" v-on:click="scrollToFormTab()">輸送費のお見積りは<span>コチラ</span></a>
          <p class="dangerous__button__txt">危険物輸送について詳しく知りたい方はこちら：<a href="https://www.mclogi.com/ChemicalsAndHazardousMaterialsTransportation.pdf" target="_blank">三菱商事ロジスティクスHP(解説記事)</a></p>
        </div>
      </div>
    </section>
    
    <section class="faq" id="faq">
      <div class="content">
        <div class="faq__title">
          <h2>よくある質問</h2>
        </div>
        <div class="faq__lists">
          <ul>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>だれでも利用できますか？</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>はい。法人様であれば、どなたでもご利用いただけます。</p> 	
</div>
            </li>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>どの輸送モードが利用できますか？</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>国際海上輸送とそれに紐づくトラック輸送、梱包、通関など一連の物流手配が可能です。但し、現時点では航空輸送は対象外です。</p> 	
</div>
            </li>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>国内だけの輸送にも対応していますか？</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>本サービスは国際輸送に限定させて頂いております。国内のみの御依頼については、ページ最上部「お問い合わせ」よりご依頼ください。</p> 	
</div>
            </li>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>海外における輸送や通関にも対応していますか？</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>はい。当社海外支店もしくはパートナー会社と協力の上、海外においても物流サービスを提案いたします。</p> 	
</div>
            </li>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>コンテナに入らない大きな貨物も対応できますか？</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>はい。”コンテナ種類選択”にて、ご希望のコンテナ種類をご選択ください。どのコンテナが適切かわからない場合には、“相談したい”を選択してください。詳細を別途メール等で確認の上、最適なプランをご提案いたします。</p> 	
</div>
            </li>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>具体的な船積み時期・内容が未定でも使用できますか？</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>はい。「まずは大雑把な費用感だけ知りたい」といった調査目的でのご利用も大歓迎ですので、お気軽にご利用ください。</p> 	
</div>
            </li>
          </ul>
        </div>
      </div>
    </section>

  </main>

  <footer>
    <div class="footer__title">
      <h2>三菱商事ロジスティクスについて</h2>
      <p>三菱商事ロジスティクスは、自動車、アパレル、食品、消費財、工業財など<br>幅広い商材の物流サービスを提供する総合物流企業です。</p>
    </div>
    <div class="footer__about">
      <ul>
        <li> 	
<span>社名</span> 	
<p>三菱商事ロジスティクス株式会社</p> 	
</li>
        <li> 	
<span>本社所在地</span> 	
<p>東京都千代田区有楽町二丁目10番1号</p> 	
</li>
        <li> 	
<span>資本金</span> 	
<p>10億6,700万円</p> 	
</li>
        <li> 	
<span>代表者</span> 	
<p>代表取締役 社長執行役員 岩井孝介</p> 	
</li>
        <li> 	
<span>資本構成</span> 	
<p>三菱商事100%</p> 	
</li>
        <li> 	
<span>サービス</span> 	
<p>生産から消費までの物流の全領域をカバー。顧客の経営課題解決のために、輸送や保管・通関を行う協力会社とともに、物流のマネジメントから企画立案や消費の予測まで携わっています。</p> 	
</li>
        <li> 	
<span>設立</span> 	
<p>1954年4月</p> 	
</li>
      </ul>
    </div>
    <div>
      <br/>
      <a href="https://www.trucxing.com/" target="_blank">
        <img src="../assets/image/truxing.png" alt="国内トラックにお困りの方は、空きスペースを活用したサスティナブルな物流、三菱食品のtrucXing(トラクシング)をご利用ください"/>
      </a>
      <br/>
      <a href="https://warex.ai/?utm_source=mclogi" target="_blank"> 	
        <img src="../assets/image/warex.jpeg" alt="倉庫探しはGaussy(ガウシー)のWareX(ウェアエックス)、全国1,400ヶ所以上の倉庫から希望条件に合った倉庫が見つかります。"> 	
      </a> 	
    </div>
    <div class="footer__link">
      <a href="https://www.mclogi.com" target="_blank">
        <div class="footer__logo">
          <img src="../assets/image/17.jpg" alt="三菱商事ロジスティクス株式会社 MCLOGI" width="1134" height="80" />
        </div>
        <div class="footer__text">〒100-0006 東京都千代田区有楽町二丁目10番1号<br> 	
<span>Copyright©2023, Mitsubishi Corporation LT, Inc. All Rights Reserved.</span> 	
</div>
      </a>
    </div>
  </footer>
</template>

<script>
import axios from 'axios'
import dummy from '@/dummy'

export default {
  name: 'LandingPage',
  data: function () {
    return {
      campaigns:[
        { pic_id:'one', alt: '船会社のオーシャンネットワークエクスプレスジャパン Ocean Network Express', },
        { pic_id:'cnc', alt: '船会社のCNC', },
        { pic_id:'kmtc', alt: '会社の高麗海運ジャパン KMTC', },
        { pic_id:'cosco', alt: '船会社のCOSCO コスコジャパン', },
        { pic_id:'kambarakisen', alt: '船会社の神原汽船 Kambara Kisen', },
        { pic_id:'i_line', alt: '船会社のI-LINE 愛媛オーシャン・ライン', },
        { pic_id:'heung_a_line', alt: '船会社の興亜LINE HEUNG A', },
        { pic_id:'sinokor', alt: '船会社の長錦商船 SINOKOR', },
        { pic_id:'evergreen', alt: '船会社のEVERGREEN SHIPPING エバーグリーンジャパン', },
        { pic_id:'ck_maritime', alt: '船会社のC. K. MARITIME CO., LTD. シーケー・マリタイム', },
        { pic_id:'numsung', alt: '船会社のNAMSUNG SHIPPING 南星海運ジャパン', },
        { pic_id:'wan_hai_lines', alt: '船会社のWAN HAI LINES ワンハイジャパン', },
        { pic_id:'oocl', alt: '会社のORIENT OVERSEAS CONTAINER LINES オーオーシーエルジャパン', },
        { pic_id:'Interasia', alt: '船会社のINTERASIA LINES インターエイシアライン', },
        { pic_id:'HMM', alt: '船会社のHMM　ヒュンダイ', },
        { pic_id:'HAPAG', alt: '船会社のHAPAG LLOYD ハパックロイド', },
        { pic_id:'sinotrans', alt: '船会社のSINOTRANS シノトランス', },
        { pic_id:'message', alt: '参加船社募集中', },
      ],

      dialogModal: false,
      rough_estimate: {
        person_in_charge:  '',
        company_name:  '',
        email:  '',
        email_conf: '',
        tel:   '',
        cargo_contents:  '',
        purpose_of_inquiry_type:  -1,
        purpose_of_inquiry_text:  '',

        transport_fee_tab: 0,
        export_import_flg: 0,
        exp: {
          e_place_flg: 1,
          e_consultation: false,
          e_shipping: false,
          e_packaging: true,
          e_banning: true,
          e_drayage: true,
          e_pickup_address:  '',
          e_customs_clearance: true,
          
          i_place_flg: 0,
          i_consultation: false,
          i_customs_clearance: false,
          i_drayage: false,
          i_devanning: false,
          i_unpacking: false,
          i_delivery: false,
          i_shipping_address:  '',
        },
        imp: {
          i_place_flg: 1,
          i_consultation: false,
          i_customs_clearance: true,
          i_drayage: true,
          i_devanning: false,
          i_unpacking: false,
          i_delivery: false,
          i_shipping_address:  '',

          e_place_flg: 0,
          e_consultation: false,
          e_shipping: false,
          e_packaging: false,
          e_banning: false,
          e_drayage: false,
          e_pickup_address:  '',
          e_customs_clearance: false,
        },
        cargo_insurance: 0,
        cargo_packaging: -1,
        weight: '',
        m3: '',
        shipping_time: -1,

        request:  '',
        desired_transportation_fee:  '',
      },   
      sea_route_inquiry: [
        {
          pol: '',
          pod: '',
          container_type_20ft: 0,
          container_type_40ft: 0,
          container_type: 0,
          dangerous_goods: 0,
          number_of_shipments: '',
          direct_delivery: 0,
        }
      ],
      privacy_chk: false,
      errors1:[],
      errors2:[],
      required_errors:[],
      format_errors:[],
      invalid_domains: [
        '@gmail.com',
        '@yahoo.co.jp',
        '@ymail.ne.jp',
        '@aol.jp',
        '@tutanota.com',
        '@outlook.jp',
        '@outlook.com',
        '@live.com',
        '@hotmail.com',
        '@live.jp',
        '@icloud.com',
        '@protonmail.com',
        '@mprotonmail.ch',
        '@vivaldi.net',
        '@tutao.de',
        '@inbox.lv',
        '@5x2.de',
        '@acht.bar',
        '@@ist-echt.so',
        '@ezweb.ne.jp',
        '@ido.ne.jp',
        '@biz.ezweb.ne.jp',
        '@augps.ezweb.ne.jp',
        '@uqmobile.jp',
        '@docomo.ne.jp',
        '@mopera.net',
        '@dwmail.jp',
        '@pdx.ne.jp',
        '@wcm.ne.jp',
        '@willcom.com',
        '@y-mobile.ne.jp',
        '@emnet.ne.jp',
        '@emobile-s.ne.jp',
        '@emobile.ne.jp',
        '@ymobile1.ne.jp',
        '@ymobile.ne.jp',
        '@jp-c.ne.jp',
        '@jp-d.ne.jp',
        '@jp-h.ne.jp',
        '@jp-k.ne.jp',
        '@jp-n.ne.jp',
        '@jp-q.ne.jp',
        '@jp-r.ne.jp',
        '@jp-s.ne.jp',
        '@jp-t.ne.jp',
        '@sky.tkc.ne.jp',
        '@sky.tkk.ne.jp',
        '@sky.tu-ka.ne.jp',
        '@disney.ne.jp',
        '@i.softbank.jp',
        '@softbank.ne.jp',
        '@vodafone.ne.jp',
        '@au.com',
        '@rakuten.jp',
        '@yahoo.ne.jp',
      ],
      ports:[],
      container_types: [
        {id: 0,	container_type: 'ドライ(GP)' },
        {id: 1,	container_type: 'リーファー(RF)' },
        {id: 2,	container_type: 'オープントップ(OT)' },
        {id: 3,	container_type: 'フラットラック(FR）' },
        {id: 4,	container_type: '相談したい' },
      ],
      cargo_packagings:[
        {id: -1,	cargo_packaging: '' },
        {id: 0,	cargo_packaging: 'パレット' },
        {id: 1,	cargo_packaging: 'バラ積み' },
        {id: 2,	cargo_packaging: 'その他' },
      ],
      shipping_times: [
        {id: -1,	shipping_time: '' },
        {id: 0,	shipping_time: '一か月以内' },
        {id: 1,	shipping_time: '三か月以内' },
        {id: 2,	shipping_time: '三か月以上先/未定' },
      ],
      landSea_purposes: [
        // {id: 0,	landSea_purpose: '価格・条件次第では、具体的な輸送について検討したい' },
        // {id: 1,	landSea_purpose: '既存取引における輸送費の妥当性を検証したい' },
        // {id: 2,	landSea_purpose: '新しい海外ビジネスを始めるにあたり、輸送費が知りたい' },
        // {id: 3,	landSea_purpose: '出荷予定はないが、輸送費の相場だけ知りたい' },
        {id: 5,	landSea_purpose: '輸送業者を探している' },
        {id: 6,	landSea_purpose: '新ビジネスの輸送費を試算したい' },
        {id: 7,	landSea_purpose: '輸送費の相場のみ知りたい' },
        {id: 4,	landSea_purpose: 'その他 (自由記述)' },
      ],
      inquiry: {
        email: 'cs.digital@mclogi.com',
        subject: 'お問い合わせ',
        body: `三菱商事ロジスティクス
デジタルフォワーディング担当者


以下の件につき、ご確認お願い致します。

=お問い合わせ内容=






貴社名：
お名前：`,
      }
    }
  },
  computed: {
      mailtoLink() {
          return `${this.inquiry.email}?subject=${encodeURIComponent(this.inquiry.subject)}&body=${encodeURIComponent(this.inquiry.body)}`;
      }
  },
  created: function () {
    this.fetchPorts()

    const queryString = window.location.search.substring(1)
    const queryParameters = {}
    queryString.split("&").forEach((pair) => {
      const [key, value] = pair.split("=")
      queryParameters[key] = decodeURIComponent(value)
    })
    if(queryParameters.tab != null) {
      this.rough_estimate.transport_fee_tab = Number(queryParameters.tab) - 1
      console.log(this.rough_estimate.transport_fee_tab)
    }
  },
  methods: {
    errCheck1: function () {
      this.trackTmpRegistPre()
      this.errors1 = []
      let valid_cnt = 0
      for (let array_item of this.sea_route_inquiry) {
        if (array_item.pol.trim().length == 0 &&
          array_item.pod.trim().length == 0 &&
          array_item.container_type_20ft == 0 &&
          array_item.container_type_40ft == 0 &&
          array_item.container_type == 0 &&
          array_item.dangerous_goods == 0 &&
          array_item.number_of_shipments.toString().trim().length == 0 &&
          array_item.direct_delivery == 0) {
          continue
        } else {
          valid_cnt += 1
        }
        if (array_item.pol.trim().length == 0) {
          this.errors1.push('「積港(POL)」を入力してください')
        } else {
          if (this.getPortIdByName(array_item.pol) == -1) {
            this.errors1.push('「積港(POL)」を正しく入力してください')
          }
        }
        if (array_item.pod.trim().length == 0) {
          this.errors1.push('「揚港(POD)」を入力してください')
        } else {
          if (this.getPortIdByName(array_item.pod) == -1) {
            this.errors1.push('「揚港(POD)」を正しく入力してください')
          }
        }
        if (array_item.container_type_20ft == 0 && array_item.container_type_40ft == 0) {
          this.errors1.push('「コンテナタイプ」のいずれかをチェックしてください')
        }
        if (array_item.container_type == -1) {
          this.errors1.push('「コンテナタイプ」の「種類」を選択してください')
        }
        if (!/^[0-9]*$/.test(array_item.number_of_shipments.toString().trim())) {
          this.errors1.push('「出荷本数/月」は半角数字の整数で入力してください')
        }
      }
      
      if (valid_cnt == 0) {
        this.errors1.push('航路データ入力が1件もありません')
      }

      if ((!/^[0-9]*$/.test(this.rough_estimate.weight.toString().trim()))) {
        this.errors1.push('「重量(Kg)/CNTR」は半角数字の整数で入力してください')
      }
      if ((!/^[0-9]*$/.test(this.rough_estimate.m3.toString().trim()))) {
        this.errors1.push('「M3/CNTR」は半角数字の整数で入力してください')
      }
      if (this.errors1.length == 0) {
        this.dialogModal = true
      }
      return this.errors1.length == 0
    },
    errCheck2: function () {
      this.errors2 = []
      this.required_errors = []
      this.format_errors = []
      if (this.rough_estimate.person_in_charge.trim().length == 0) {
        this.required_errors.push('「お名前」')
      }
      if (this.rough_estimate.company_name.trim().length == 0) {
        this.required_errors.push('「会社名」')
      }
      let email_exist = false
      if (this.rough_estimate.email.trim().length == 0) {
        this.required_errors.push('「配信先アドレス」')
      } else {
        if (!/^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/.test(this.rough_estimate.email.trim())){
          this.format_errors.push('「配信先アドレス」')
        } else {
          let domain_str = this.rough_estimate.email.trim()
          domain_str = domain_str.substring(domain_str.indexOf('@'))
          console.log(domain_str)
          if(this.invalid_domains.includes(domain_str)) {
            this.errors2.push('フリーメール・キャリアメールはご利用いただけません')
          }
          email_exist = true
        }
      }
      let email_conf_exist = false
      if (this.rough_estimate.email_conf.trim().length == 0) {
        this.required_errors.push('「配信先アドレス(再入力)」')
      } else {
        if (!/^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/.test(this.rough_estimate.email_conf.trim())){
          this.format_errors.push('「配信先アドレス(再入力)」')
        } else {
          email_conf_exist = true
        }
      }
      if (email_exist && email_conf_exist) {
        if (this.rough_estimate.email.trim() != this.rough_estimate.email_conf.trim()){
          this.errors2.push('「配信先アドレス」と「配信先アドレス(再入力)」が一致していません')
        }
      }
      if (this.rough_estimate.tel.trim().length == 0) {
        this.required_errors.push('「電話番号」')
      } else {
        if (!/^[0-9]*$/.test(this.rough_estimate.tel.trim())){
          this.format_errors.push('「電話番号」')
        }
      }
      if (this.rough_estimate.cargo_contents.trim().length == 0) {
        this.required_errors.push('「貨物内容」')
      }
      if (this.rough_estimate.purpose_of_inquiry_type == -1) {
        this.required_errors.push('「お問い合わせ目的」')
      }
      if (this.rough_estimate.purpose_of_inquiry_type == 4 && this.rough_estimate.purpose_of_inquiry_text.trim().length == 0) {
        this.required_errors.push('「お問い合わせ目的(自由記述)」')
      }
      if (!this.privacy_chk) {
        this.errors2.push('「利用規約」が同意されていません')
      }

      if(this.format_errors.length > 0){
        this.errors2.unshift(this.format_errors.join('') + 'が不正です')
      }
      if(this.required_errors.length > 0){
        this.errors2.unshift(this.required_errors.join('') + 'を入力してください')
      }
      return this.errors2.length == 0
    },
    addSeaRouteInquiry: function () {
      this.sea_route_inquiry.push(
        {
          pol: '',
          pod: '',
          container_type_20ft: 0,
          container_type_40ft: 0,
          container_type: 0,
          dangerous_goods: 0,
          number_of_shipments: '',
          direct_delivery: 0,
        }
      )
    },
    postRequest: function () {
      this.trackTmpRegist()
      if (this.errCheck2()) {
        let post_json = {
          status: 'insert',
          disp:	'rough_estimate',
          rough_estimate:	{
            company_name: this.rough_estimate.company_name,
            person_in_charge: this.rough_estimate.person_in_charge,
            email: this.rough_estimate.email,
            cargo_contents: this.rough_estimate.cargo_contents,
            tel: this.rough_estimate.tel,
            transport_fee_tab: Number(this.rough_estimate.transport_fee_tab),
            request: this.rough_estimate.request,
            desired_transportation_fee: this.rough_estimate.desired_transportation_fee,
            purpose_of_inquiry_type: this.rough_estimate.purpose_of_inquiry_type,
            purpose_of_inquiry_text: this.rough_estimate.purpose_of_inquiry_text,
            sea_route_inquiry: []
          }
        }
        if(post_json.rough_estimate.transport_fee_tab == 1){
          post_json.rough_estimate.export_import_flg = Number(this.rough_estimate.export_import_flg)
          if(post_json.rough_estimate.export_import_flg == 0) {
            post_json.rough_estimate.e_consultation = Number(this.rough_estimate.exp.e_consultation)
            post_json.rough_estimate.e_place_flg = Number(this.rough_estimate.exp.e_place_flg)
            if(post_json.rough_estimate.e_place_flg == 1) {
              post_json.rough_estimate.e_shipping = Number(this.rough_estimate.exp.e_shipping)
              post_json.rough_estimate.e_packaging = Number(this.rough_estimate.exp.e_packaging)
              post_json.rough_estimate.e_banning = Number(this.rough_estimate.exp.e_banning)
              post_json.rough_estimate.e_drayage = Number(this.rough_estimate.exp.e_drayage)
              post_json.rough_estimate.e_customs_clearance = Number(this.rough_estimate.exp.e_customs_clearance)
              post_json.rough_estimate.e_pickup_address = this.rough_estimate.exp.e_pickup_address
            }
            post_json.rough_estimate.i_consultation = Number(this.rough_estimate.exp.i_consultation)
            post_json.rough_estimate.i_place_flg = Number(this.rough_estimate.exp.i_place_flg)
            if(post_json.rough_estimate.i_place_flg == 1) {
              post_json.rough_estimate.i_customs_clearance = Number(this.rough_estimate.exp.i_customs_clearance)
              post_json.rough_estimate.i_drayage = Number(this.rough_estimate.exp.i_drayage)
              post_json.rough_estimate.i_devanning = Number(this.rough_estimate.exp.i_devanning)
              post_json.rough_estimate.i_unpacking = Number(this.rough_estimate.exp.i_unpacking)
              post_json.rough_estimate.i_delivery = Number(this.rough_estimate.exp.i_delivery)
              post_json.rough_estimate.i_shipping_address = this.rough_estimate.exp.i_shipping_address
            }
          } else if (post_json.rough_estimate.export_import_flg == 1) { 
            post_json.rough_estimate.i_consultation = Number(this.rough_estimate.imp.i_consultation)
            post_json.rough_estimate.i_place_flg = Number(this.rough_estimate.imp.i_place_flg)
            if(post_json.rough_estimate.i_place_flg == 1) {
              post_json.rough_estimate.i_customs_clearance = Number(this.rough_estimate.imp.i_customs_clearance)
              post_json.rough_estimate.i_drayage = Number(this.rough_estimate.imp.i_drayage)
              post_json.rough_estimate.i_devanning = Number(this.rough_estimate.imp.i_devanning)
              post_json.rough_estimate.i_unpacking = Number(this.rough_estimate.imp.i_unpacking)
              post_json.rough_estimate.i_delivery = Number(this.rough_estimate.imp.i_delivery)
              post_json.rough_estimate.i_shipping_address = this.rough_estimate.imp.i_shipping_address
            }
            post_json.rough_estimate.e_consultation = Number(this.rough_estimate.imp.e_consultation)
            post_json.rough_estimate.e_place_flg = Number(this.rough_estimate.imp.e_place_flg)
            if(post_json.rough_estimate.e_place_flg == 1) {
              post_json.rough_estimate.e_shipping = Number(this.rough_estimate.imp.e_shipping)
              post_json.rough_estimate.e_packaging = Number(this.rough_estimate.imp.e_packaging)
              post_json.rough_estimate.e_banning = Number(this.rough_estimate.imp.e_banning)
              post_json.rough_estimate.e_drayage = Number(this.rough_estimate.imp.e_drayage)
              post_json.rough_estimate.e_customs_clearance = Number(this.rough_estimate.imp.e_customs_clearance)
              post_json.rough_estimate.e_pickup_address = this.rough_estimate.imp.e_pickup_address
            }
          }
          post_json.rough_estimate.cargo_insurance = Number(this.rough_estimate.cargo_insurance)
          post_json.rough_estimate.cargo_packaging = Number(this.rough_estimate.cargo_packaging)
          if(this.rough_estimate.weight.trim().length > 0) {
            post_json.rough_estimate.weight = Number(this.rough_estimate.weight)
          } else {
            post_json.rough_estimate.weight = -1
          }
          if(this.rough_estimate.m3.trim().length > 0) {
            post_json.rough_estimate.m3 = Number(this.rough_estimate.m3)
          } else {
            post_json.rough_estimate.m3 = -1
          }
          post_json.rough_estimate.shipping_time = Number(this.rough_estimate.shipping_time)
        }
        for (let array_item of this.sea_route_inquiry) {
          if (array_item.pol.trim().length == 0 &&
            array_item.pod.trim().length == 0 &&
            array_item.container_type_20ft == 0 &&
            array_item.container_type_40ft == 0 &&
            array_item.container_type == 0 &&
            array_item.dangerous_goods == 0 &&
            array_item.number_of_shipments.toString().trim().length == 0 &&
            array_item.direct_delivery == 0 ) {
            continue
          }
          let sea_route_inquiry = {
            pol_id: this.getPortIdByName(array_item.pol),
            pod_id: this.getPortIdByName(array_item.pod),
            container_type_20ft: Number(array_item.container_type_20ft),
            container_type_40ft: Number(array_item.container_type_40ft),
            container_type: Number(array_item.container_type),
            dangerous_goods: Number(array_item.dangerous_goods),
            number_of_shipments: -1,
            direct_delivery: Number(array_item.direct_delivery),
          }
          if(array_item.number_of_shipments.toString().trim().length > 0) {
            sea_route_inquiry.number_of_shipments = Number(array_item.number_of_shipments)
          }
          post_json.rough_estimate.sea_route_inquiry.push(sea_route_inquiry)
        }

        // console.log(post_json)
        axios.post(process.env.VUE_APP_API_URL_BASE + process.env.VUE_APP_API_EXEC, post_json)
          .then( (response) => {
            var res = response.data;
            if( res.status === 'done' ) {
              console.log(res)
              this.dialogModal = false
              setTimeout(() => {
                alert('送信が完了しました。追って担当者よりご連絡します')
              }, 200)
              this.clearAll()
            } else if( res.result === 'error' ) {
              console.log(res.msg)
              this.errors2.push('システムエラーが発生しました')
            } else {
              console.log(res)
              this.errors2.push('システムエラーが発生しました')
            }
          })
          .catch((error) => {
            if (process.env.VUE_APP_ENV === 'dev') {
              this.dialogModal = false
              setTimeout(() => {
                alert('送信が完了しました。追って担当者よりご連絡します')
              }, 200)
              this.clearAll()
            } else {
              console.log(error)
              this.errors2.push('システムエラーが発生しました')
            }
          })
        }
    },
    tabChanged: function () {
      this.errors1 = []
    },
    popupAgreement: function () {
      window.open('shipper_agreement_lp.pdf', '_blank', 'menubar=no,toolbar=no,location=no,status=no')
    },
    defaultExpExp: function() {
      this.rough_estimate.exp.e_shipping = false
      this.rough_estimate.exp.e_packaging = true
      this.rough_estimate.exp.e_banning = true
      this.rough_estimate.exp.e_drayage = true
      this.rough_estimate.exp.e_pickup_address = ''
      this.rough_estimate.exp.e_customs_clearance = true
    },
    defaultExpImp: function() {
      this.rough_estimate.exp.i_customs_clearance = true
      this.rough_estimate.exp.i_drayage = true
      this.rough_estimate.exp.i_devanning = false
      this.rough_estimate.exp.i_unpacking = false
      this.rough_estimate.exp.i_delivery = false
      this.rough_estimate.exp.i_shipping_address = ''
    },
    defaultImpImp: function() {
      this.rough_estimate.imp.i_customs_clearance = true
      this.rough_estimate.imp.i_drayage = true
      this.rough_estimate.imp.i_devanning = false
      this.rough_estimate.imp.i_unpacking = false
      this.rough_estimate.imp.i_delivery = false
      this.rough_estimate.imp.i_shipping_address = ''
    },
    defaultImpExp: function() {
      this.rough_estimate.imp.e_shipping = false
      this.rough_estimate.imp.e_packaging = true
      this.rough_estimate.imp.e_banning = true
      this.rough_estimate.imp.e_drayage = true
      this.rough_estimate.imp.e_pickup_address = ''
      this.rough_estimate.imp.e_customs_clearance = true
    },
    clearExpExp: function() {
      this.rough_estimate.exp.e_shipping = false
      this.rough_estimate.exp.e_packaging = false
      this.rough_estimate.exp.e_banning = false
      this.rough_estimate.exp.e_drayage = false
      this.rough_estimate.exp.e_pickup_address = ''
      this.rough_estimate.exp.e_customs_clearance = false
    },
    clearExpImp: function() {
      this.rough_estimate.exp.i_customs_clearance = false
      this.rough_estimate.exp.i_drayage = false
      this.rough_estimate.exp.i_devanning = false
      this.rough_estimate.exp.i_unpacking = false
      this.rough_estimate.exp.i_delivery = false
      this.rough_estimate.exp.i_shipping_address = ''
    },
    clearImpImp: function() {
      this.rough_estimate.imp.i_customs_clearance = false
      this.rough_estimate.imp.i_drayage = false
      this.rough_estimate.imp.i_devanning = false
      this.rough_estimate.imp.i_unpacking = false
      this.rough_estimate.imp.i_delivery = false
      this.rough_estimate.imp.i_shipping_address = ''
    },
    clearImpExp: function() {
      this.rough_estimate.imp.e_shipping = false
      this.rough_estimate.imp.e_packaging = false
      this.rough_estimate.imp.e_banning = false
      this.rough_estimate.imp.e_drayage = false
      this.rough_estimate.imp.e_pickup_address = ''
      this.rough_estimate.imp.e_customs_clearance = false
    },
    clearAll: function () {
      let save_tab = this.rough_estimate.transport_fee_tab
      this.rough_estimate =  {
        person_in_charge:  '',
        company_name:  '',
        email:  '',
        email_conf: '',
        tel:   '',
        cargo_contents:  '',
        purpose_of_inquiry_type:  -1,
        purpose_of_inquiry_text:  '',

        transport_fee_tab: save_tab,
        export_import_flg: 0,
        exp: {
          e_place_flg: 1,
          e_consultation: 0,
          e_shipping: 0,
          e_packaging: 0,
          e_banning: 0,
          e_drayage: 0,
          e_pickup_address:  '',
          e_customs_clearance: 0,
          
          i_place_flg: 0,
          i_consultation:  0,
          i_customs_clearance: 0,
          i_drayage: 0,
          i_devanning: 0,
          i_unpacking: 0,
          i_delivery: 0,
          i_shipping_address:  '',
        },
        imp: {
          i_place_flg: 1,
          i_consultation:  0,
          i_customs_clearance: 0,
          i_drayage: 0,
          i_devanning: 0,
          i_unpacking: 0,
          i_delivery: 0,
          i_shipping_address:  '',

          e_place_flg: 0,
          e_consultation: 0,
          e_shipping: 0,
          e_packaging: 0,
          e_banning: 0,
          e_drayage: 0,
          e_pickup_address:  '',
          e_customs_clearance: 0,
        },
        cargo_insurance: 0,
        cargo_packaging: -1,
        weight: '',
        m3: '',
        shipping_time: -1,

        request:  '',
        desired_transportation_fee:  '',
      }
      this.sea_route_inquiry = [
        {
          pol: '',
          pod: '',
          container_type_20ft: 0,
          container_type_40ft: 0,
          container_type: 0,
          dangerous_goods: 0,
          number_of_shipments: '',
          direct_delivery: 0,
        }
      ]
      this.privacy_chk = false
    },
    fetchPorts: function () {
      let post_json = {
        status: 'select',
        info:	'port_master',
      }
      axios.post(process.env.VUE_APP_API_URL_BASE + process.env.VUE_APP_API_EXEC, post_json)
        .then( (response) => {
          var res = response.data;
          if( res.status === 'done' ) {
            this.ports = res.port_master
          } else if( res.result === 'error' ) {
            console.log(res.msg)
          } else {
            console.log(res)
          }
        })
        .catch(error => {
          console.log(error)
          if (process.env.VUE_APP_ENV === 'dev') {
            this.ports = dummy.ports
          }
        })
    },
    getPortNameById: function (id) {
      let arrayItem = this.ports.find(element => element.id === id)
      return arrayItem ? arrayItem.short_name : ''
    },
    getPortIdByName: function (name) {
      let arrayItem = this.ports.find(element => element.short_name === name)
      return arrayItem ? arrayItem.id : -1
    },
    trackDownload: function () {
      if (process.env.VUE_APP_ENV === 'production') {
        // eslint-disable-next-line no-undef
        // gtag('event', 'conversion', {
        //   send_to: 'AW-11319887392/eJoTCP3G7-YYEKCM35Uq',
        // })
      }
      // eslint-disable-next-line no-undef
      // gtag('event', 'conversion_test1', {
      //   send_to: 'TEST-0000000001',
      // })
    },
    trackMailTo: function () {
      if (process.env.VUE_APP_ENV === 'production') {
        // eslint-disable-next-line no-undef
        // gtag('event', 'conversion', {
        //   send_to: 'AW-11319887392/yHkSCIiY9uYYEKCM35Uq',
        // })
      }
      // eslint-disable-next-line no-undef
      // gtag('event', 'conversion_test2', {
      //   send_to: 'TEST-0000000002',
      // })
      window.location.href = `mailto:${this.mailtoLink}`;
    },
    trackTmpRegist: function () {
      if (process.env.VUE_APP_ENV === 'production') {
        // eslint-disable-next-line no-undef
        // gtag('event', 'conversion', {
        //   send_to: 'AW-11319887392/ZP2aCI2X9uYYEKCM35Uq',
        // })
      }
      // eslint-disable-next-line no-undef
      // gtag('event', 'conversion_test4', {
      //   send_to: 'TEST-0000000004',
      // })
    },
    trackTmpRegistPre: function () {
      if (process.env.VUE_APP_ENV === 'production') {
        // eslint-disable-next-line no-undef
        // gtag('event', 'conversion', {
        //   send_to: 'AW-11319887392/yS-qCNS_p-gYEKCM35Uq',
        // })
      }
      // eslint-disable-next-line no-undef
      // gtag('event', 'conversion_test5', {
      //   send_to: 'TEST-0000000005',
      // })
    },
    scrollToFormTab: function() {
      this.$refs["form_tab"].scrollIntoView({ behavior: 'smooth' });
    },
  }
}
</script>

<style scoped>
@import '../assets/css/main.css';
.select-placeholder  {
  color: lightgray; 
}

</style>